export default __webpack_public_path__ + "static/media/couple-contact.32905cff.webp";